import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NamedRouterOutletModule } from '@y42/angular/router';
import { IntercomModule } from '@y42/intercom';
import { SidebarComponent } from './sidebar.component';

@NgModule({
  declarations: [SidebarComponent],
  exports: [SidebarComponent, NamedRouterOutletModule],
  imports: [
    CommonModule,
    RouterModule,

    MatButtonModule,
    MatSidenavModule,
    FontAwesomeModule,

    IntercomModule,
    NamedRouterOutletModule,
  ],
})
export class SidebarModule {}
